/**
 * Export Button Component
 * - Provides data export functionality
 * - Navigates to export page with filtered data
 * - Supports different export types (users, blogs, etc.)
 */

// import React from "react";
// import { FiDownload } from "react-icons/fi";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";


// const ExportButton = ({ data, columns, fileName = "export", format = "XLSX" }) => {
//   const handleExport = () => {
//     if (!data || data.length === 0) {
//       alert("No data available to export!");
//       return;
//     }

//     // Prepare export data
//     const exportData = columns
//       ? data.map((row) => {
//           const filteredRow = {};
//           columns.forEach((col) => {
//             filteredRow[col.label] = row[col.key];
//           });
//           return filteredRow;
//         })
//       : data;

//     if (format === "XLSX") {
//       const worksheet = XLSX.utils.json_to_sheet(exportData);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
//       XLSX.writeFile(workbook, `${fileName}.xlsx`);
//     } else if (format === "CSV") {
//       const worksheet = XLSX.utils.json_to_sheet(exportData);
//       const csv = XLSX.utils.sheet_to_csv(worksheet);
//       const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);
//       link.setAttribute("download", `${fileName}.csv`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } else if (format === "PDF") {
//   if (!exportData || exportData.length === 0) {
//     alert("No data available to export!");
//     return;
//   }

//   const doc = new jsPDF();
//   const tableColumn = columns ? columns.map((col) => col.label) : Object.keys(exportData[0]);
//   const tableRows = exportData.map((row) =>
//     columns ? columns.map((col) => row[col.key]) : Object.values(row)
//   );

//   // Correct way to call autoTable
//   autoTable(doc, {
//     head: [tableColumn],
//     body: tableRows,
//   });

//   doc.save(`${fileName.replace(/\.[^/.]+$/, "")}.pdf`); // removes extension if exists
// } else {
//   alert("Unsupported export format!");
// }
//   };

//   return (
//     <button
//       onClick={handleExport}
//       className="flex items-center gap-2 bg-[#347DFF] hover:bg-blue-600 text-white text-lg font-medium px-7 py-2.5 rounded-lg shadow transition"
//     >
//       Export <FiDownload className="w-5 h-5" />
//     </button>
//   );
// };

// export default ExportButton;



import React from "react";
import { FiDownload } from "react-icons/fi";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ExportButton = ({ data, columns, fileName = "export", format = "CSV" }) => {
  const handleExport = () => {
    if (!data || data.length === 0) {
      alert("No data available to export!");
      return;
    }

    const exportData = columns
      ? data.map((row) => {
          const filteredRow = {};
          columns.forEach((col) => {
            filteredRow[col.label] = row[col.key];
          });
          return filteredRow;
        })
      : data;

    // ✅ CSV EXPORT (Excel-compatible)
    if (format === "CSV") {
      const headers = Object.keys(exportData[0]).join(",");
      const rows = exportData.map((row) =>
        Object.values(row)
          .map((value) => `"${String(value).replace(/"/g, '""')}"`)
          .join(",")
      );

      const csvContent = [headers, ...rows].join("\n");

      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.click();
    }

    // ✅ PDF EXPORT
    else if (format === "PDF") {
      const doc = new jsPDF();
      const tableColumn = columns
        ? columns.map((col) => col.label)
        : Object.keys(exportData[0]);

      const tableRows = exportData.map((row) =>
        columns ? columns.map((col) => row[col.key]) : Object.values(row)
      );

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
      });

      doc.save(`${fileName}.pdf`);
    } else {
      alert("Unsupported export format!");
    }
  };

  return (
    <button
      onClick={handleExport}
      className="flex items-center gap-2 bg-[#347DFF] hover:bg-blue-600 text-white text-lg font-medium px-7 py-2.5 rounded-lg shadow transition"
    >
      Export <FiDownload className="w-5 h-5" />
    </button>
  );
};

export default ExportButton;
